var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeacherAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.56 11.572h-.339a5.31 5.31 0 0 1-4.44 0h-.34a4.265 4.265 0 0 0-4.25 3.92c-.016.201.148.322.319.433.611.4 3.714.886 6.491.886 2.777 0 5.591-.485 6.491-.886.185-.082.335-.232.319-.434a4.266 4.266 0 0 0-4.251-3.919M6.102 7.09a3.9 3.9 0 1 1 7.798-.002 3.9 3.9 0 0 1-7.798.002",
  fillRule: "evenodd"
})));
export default SvgTeacherAvatar;